import { render, staticRenderFns } from "./SettingsAdminEdit.vue?vue&type=template&id=0de868aa&"
import script from "./SettingsAdminEdit.vue?vue&type=script&lang=js&"
export * from "./SettingsAdminEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports